/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { CircularProgress } from "@material-ui/core";
import SatisfactionDetails from "./SatisfactionDetails";

import "./style.css";

import { getRequest } from "utils/request";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { i18n } from '../../translate/i18n';
import { useNotification } from "hooks/notification";
import { useModal } from "hooks/modal";
import exportExcel from "utils/exportExcel";
import format from "date-fns/format";

export default function SkuteSatisfactionSurvey() {
  const [ratings, setRatings] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [allratings, setAllRatings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedevaluation, setSelectedEvaluation] = useState("");
  const [editEvaluation, setEditEvaluation] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("Pendente");
  const [update, setUpdate] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [count, setCount] = useState(0);
  const { toggleHelperId} = useModal();
  const dt = useRef(null);

  const liststatus = [
    { value: "Pendente" },
    { value: "Aprovado" },
    { value: "Rejeitado" },
  ];

  const { selectedCompany } = useNotification();

  useEffect(() => {
    loadRatings();
    toggleHelperId(15);
  }, [update, selectedCompany.id]);

  const loadRatings = () => {
    setLoading(true);
    getRequest(
      `/satisfactionsurveys/company/${selectedCompany.id}?offset=0&limit=100000`
    )
      .then(function (response) {

        let statusFilter = response.data

        statusFilter.forEach(e => {
          if(e.score === 5) {
            e.scoreDescription = 'Excelente'
          } else if (e.score === 4) {
            e.scoreDescription = 'Bom'
          } else if (e.score === 3) {
            e.scoreDescription = 'Médio'
          } else if (e.score === 2) {
            e.scoreDescription = 'Ruim'
          } else if (e.score === 1) {
            e.scoreDescription = 'Muito ruim'
          }
        })

        setCount(1);
        setAllRatings(statusFilter);
        setRatings(statusFilter);
        setLoading(false);
      }
    )
  }

  const handleGoBack = () => {
    setEditEvaluation(false);
  };

  const handleUpdate = () => {
    setUpdate(update + 1);
    handleGoBack();
  };

  const handleChangeStatus = (value) => {
    loadRatings();
    dt.current.filter(value, 'status', 'equals');
    setSelectedStatus(value);
  };

  const actionButtonsTemplate = (data) => {
    return (
      <div style={{display: "flex", flexDirection: "row"}}>
        <div
          className="action-icon"
          style={{ cursor: "pointer", marginRight: 10 }}
          onClick={() => { setSelectedEvaluation(data);setEditEvaluation(true)}}
        >
          <i className="uil-eye" style={{fontSize: 20}}></i>
        </div>
      </div>
    )
  }

  const ticketTemplate = (data) => {
    return (
      <td>{data.Ticket.ticket}</td>
    )
  }

  const userTemplate = (data) => {
    return (
      <span>{data.Ticket.Customer.nickName ?? data.Ticket.Customer.name}</span>
    )
  }

  const emailTemplate = (data) => {
    return (
      <span>{data.Ticket.Customer.email ?? 'Não Informado'}</span>
    )
  }

  const ticketTypeTemplate = (data) => {
    return (
      <span>{data?.Ticket?.CompanyTicketType?.description ?? 'Não Informado'}</span>
    )
  }


  const phoneTemplate = (data) => {
    return (
      <span>{data.Ticket.Customer.cellPhone ?? 'Não Informado'}</span>
    )
  }

  const statusTemplate = (data) => (
    <span
      className={
        data.statusDescription === "Aprovado"
          ? "text-status-aprovado"
          : data.statusDescription === "Rejeitado"
          ? "text-status-rejeitado"
          : "text-status-pendente"
      }
    >
      {data.statusDescription}
    </span>
  )

  const handleExport = () => {
    let data = [];

    ratings.forEach(e => {
      const rating = {
        Id: e.id,
        [i18n.t('user')]: e.Ticket.Customer.nickName ?? e.Ticket.Customer.name,
        ...(selectedCompany.id === Number(process.env.REACT_APP_SKUTE_ID) && { [i18n.t('company')]: e.Ticket.Company.nickName }),
        [i18n.t('phone')]: e.Ticket.Customer.cellPhone,
        'E-Mail': e.Ticket.Customer.email,
        [i18n.t('scheduling')]: e.scoreDescription,
        [i18n.t('backToBusiness2')]: e.goBackBusinessDescription,
        Status: e.status,
        [i18n.t('message')]: e.message,
        [i18n.t('createdAt')]: format(new Date(e.createdAt ), "dd/MM/yyyy")
      }


      data.push(rating);
    })

    exportExcel(data, i18n.t('assessments') + ' SKUTE')
  }

  const header = (
    <div className="data-table-header"
    >
      <label style={{marginRight: 10}}>{i18n.t('status')}</label>
      <select
        className="input-globalfilter"
        style={{height: 40}}
        data-toggle="select2"
        required
        value={selectedStatus}
        onChange={(e) => handleChangeStatus(e.target.value)}
      >
        <option value="">{i18n.t('all')}</option>
        {liststatus.map((data, index) => (
          <option key={index} value={data.value}>
            {data.value}
          </option>
        ))}
      </select>
    </div>
  )

  return (
    <div style={{overflowY: 'auto', minHeight: 200, minWidth: '100%'}}>
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            {!editEvaluation ? (
              <>
                <div className="area-header-table-users">
                  <h4>{i18n.t('assessments')} SKUTE</h4>
                  <button type="button" onClick={handleExport} className="export-excel" >
                    <i style={{fontSize: 16, marginRight: 5}}className="pi pi-file-excel"/>
                    <span style={{fontSize: '1vw'}}>{i18n.t('exportAllData')}</span>
                  </button>
                </div>
                <div className="tab-content">
                  <div
                    className="tab-pane show active"
                    id="basic-datatable-preview"
                  >
                    {!loading ? (
                      <DataTable
                        ref={dt}
                        header={header}
                        globalFilter={selectedStatus}
                        dataKey="id"
                        rowsPerPageOptions={[25,50,100]}
                        value={ratings}
                        paginator
                        rows={25}
                        emptyMessage={i18n.t('NoReviewsFound')}
                      >
                        <Column body={ticketTemplate} header="Ticket"></Column>
                        {selectedCompany.id === Number(process.env.REACT_APP_SKUTE_ID) &&
                          <Column header={i18n.t('company')} field="Ticket.Company.nickName" sortable></Column>
                        }
                        <Column body={userTemplate} header={i18n.t('user')}></Column>
                        <Column body={phoneTemplate} header={i18n.t('phone')}></Column>
                        <Column body={emailTemplate} header={i18n.t('email')}></Column>
                        <Column field="scoreDescription" header={i18n.t('attendance')}></Column>
                        <Column body={ticketTypeTemplate} header={i18n.t('ticketType')}></Column>
                        <Column field="goBackBusinessDescription" header={i18n.t('backToBusiness2')}></Column>
                        <Column body={statusTemplate} filterField="statusDescription" field="statusDescription" header={i18n.t('status')}></Column>
                        <Column body={actionButtonsTemplate} header={i18n.t('action')}></Column>
                      </DataTable>
                    ) : (
                      <div className="area-loading">
                        <CircularProgress />
                      </div>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <SatisfactionDetails
                selectedCompany={selectedCompany}
                handleGoBack={handleGoBack}
                selectedevaluation={selectedevaluation}
                handleUpdate={handleUpdate}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
